// extracted by mini-css-extract-plugin
export default {"cc-search-enabled__icon":"style_cc-search-enabled__icon__cTtjn","cc-search-enabled__notes":"style_cc-search-enabled__notes__2i+im"};